<template>
  <div class="grid-x cards align-center">
    <div class="cell small-11 medium-10">
      <div class="grid-x grid align-center">
        <div class="cell small-12" :class="cellClass(page)" v-for="page in pages" :key="'page' + page.id">
          <page-card :page="page"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PageCard from '@/components/PageCard.vue';

  export default {
    props: {
      pages: Array,
      columns: {
       type: [Boolean, String],
       default: false
      }
    },
    components: {
      PageCard
    },
    methods: {
      cellClass(page) {
         if (page.card.full_width) {
           return [''];
         } else if (this.columns && this.columns == 'two') {
           return ['medium-6'];
         } else {
           return ['medium-4'];
         }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'foundation-sites/scss/foundation.scss';
  @import '@/assets/scss/_settings';
  .cards {
    margin: vw-relative(50 0 24);
  }
  .grid {
    margin: 0 vw-relative(-13);
  }
</style>
